import React from 'react';

import { StatusPlanner, StatusPlan } from '@gogame/components';
import { withFormField } from '@gogame/form';

import {
  STATUS_PENDING,
  STATUS_PREVIEW,
  STATUS_ACTIVE,
  STATUS_ARCHIVED,
  STATUS_LABELS,
  STATUS_COLORS,
} from 'scenes/Gallery/GalleryPage/constants';

const StatusSchedulesField = withFormField()((props) => {
  return (
    <StatusPlanner {...props} fullWidth={true}>
      <StatusPlan
        id={STATUS_PENDING}
        label={STATUS_LABELS[STATUS_PENDING]}
        color={STATUS_COLORS[STATUS_PENDING]}
      />
      <StatusPlan
        id={STATUS_PREVIEW}
        label={STATUS_LABELS[STATUS_PREVIEW]}
        color={STATUS_COLORS[STATUS_PREVIEW]}
      />
      <StatusPlan
        id={STATUS_ACTIVE}
        label={STATUS_LABELS[STATUS_ACTIVE]}
        color={STATUS_COLORS[STATUS_ACTIVE]}
      />
      <StatusPlan
        id={STATUS_ARCHIVED}
        label={STATUS_LABELS[STATUS_ARCHIVED]}
        color={STATUS_COLORS[STATUS_ARCHIVED]}
      />
    </StatusPlanner>
  );
});

export default StatusSchedulesField;
